import "core-js/modules/es6.regexp.split";
import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import * as React from 'react';
import { fireAnalyticsTrackingEvent, interaction } from '@origin-digital/reporting-client';
import { warning } from '@origin-digital/helper';
/** @deprecated, use data-id, instead of tracking */

export var captureClick = function captureClick(tracking) {
  return function (e) {
    fireAnalyticsTrackingEvent(tracking, e);
  };
};

var captureInteraction = function captureInteraction(interactionData) {
  return function () {
    interaction('click', interactionData);
  };
};

function sendTrackableClickEvent(props) {
  var trackingDisabled = props.trackingDisabled,
      dataId = props['data-id'],
      postClickState = props.postClickState,
      componentType = props.componentType;

  if (!trackingDisabled && dataId) {
    process.env.NODE_ENV !== "production" ? warning(!!componentType, "sendClickTrackEvent(): missing componentType prop, data-id=\"".concat(dataId, "\"")) : void 0;
    var parsedDataId = parseDataId(dataId);
    var label = props.label || props.text;
    captureInteraction(_Object$assign({}, parsedDataId, {
      componentType: componentType,
      label: label,
      state: postClickState
    }))();
  }
}

function enhanceWithTrackable(Component) {
  var trackableComponent = function trackableComponent(props) {
    var trackingDisabled = props.trackingDisabled,
        dataId = props['data-id'],
        postClickState = props.postClickState,
        componentType = props.componentType; // @ts-ignore FIXME: until we deprecate tracking

    var tracking = props.tracking;
    var myComponentType = componentType || Component.displayName;

    if (!trackingDisabled && !tracking && dataId) {
      process.env.NODE_ENV !== "production" ? warning(!!myComponentType, "enhanceWithTrackable(): missing Component.displayName or componentType prop, data-id=\"".concat(dataId, "\"")) : void 0;
      var parsedDataId = parseDataId(dataId);
      var label = props.label || props.text;
      return React.createElement(Component, _extends({}, props, {
        onClickCapture: captureInteraction(_Object$assign({}, parsedDataId, {
          componentType: myComponentType,
          label: label,
          state: postClickState
        }))
      }));
    }

    var onClickCapture;

    if (!trackingDisabled && tracking) {
      process.env.NODE_ENV !== "production" ? warning(false, "@deprecated enhanceWithTrackable(): tracking=\"".concat(tracking, "\", please updated to use data-id=\"{{id}} | {{parentContainer}}:{{id}} \"")) : void 0;
      onClickCapture = captureClick(tracking);
    }

    return React.createElement(Component, _extends({}, props, {
      onClickCapture: onClickCapture
    }));
  };

  if (Component.propTypes) {
    trackableComponent.propTypes = Component.propTypes;
  }

  if (Component.displayName) {
    trackableComponent.displayName = Component.displayName;
  }

  return trackableComponent;
}

export var parseDataId = function parseDataId(dataId) {
  var pieces = dataId.split(':');

  switch (pieces.length) {
    case 1:
      return {
        id: pieces[0]
      };

    case 2:
      return {
        id: pieces[1],
        parentContainer: pieces[0]
      };

    default:
      return {
        id: dataId
      };
  }
};
export { enhanceWithTrackable, sendTrackableClickEvent };